// =============================================================================
// Asset Loading Utilities
// =============================================================================
// NOTE: All graphics are now procedurally generated - no external assets needed

/** Load all game assets */
export async function loadAssets(): Promise<void> {
  // All graphics are now procedurally generated in their respective entity classes
  // This function is kept for backwards compatibility but does nothing
  console.log("All graphics are procedurally generated - no assets to load");
}
